module.exports = __webpack_public_path__ + "static/img/magnet01.c6aaa09.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/magnet01.png
// module id = 0nEM
// module chunks = 1